export default __webpack_public_path__ + "static/media/brand-logo.5327ca5e.svg";